export default "__VITE_ASSET__e62c1aa6__"